import React from "react";
import { sha256 } from "js-sha256";
import Util from "../helpers/util";
import { useStore } from "../store";
import InputWithIcon from "../components/input_with_Icon";
import Logo from "../assets/images/shared/drip7-logo.svg";
import { useNavigate } from "react-router-dom";
import Language from "../helpers/language";

//State wrapper
const withStore = BaseComponent => props => {
    const { setCsrfIfEmpty, setUsrInfo } = useStore(state => state)

    return (
        <BaseComponent
            {...props}
            setCsrfIfEmpty={setCsrfIfEmpty}
            setUsrInfo={setUsrInfo}
            navigate={useNavigate()}
        />
    );
};

class Klass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errored: "",

            name: "",
            email: "",
            phone: "",
            password: "",
            password_repeat: ""
        };

        this.handleKeypress = this.handleKeypress.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
    }

    handleKeypress(event) {
        // Enter pressed? register
        if (event.charCode === 13) {
            this.handleRegister();
        }
    }

    handleChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({ [name]: value });
    }

    handleRegister() {
        const { email, name, phone, password, password_repeat } = this.state;

        if (password != password_repeat) {
            this.setState({ errored: Language.getString("Passwords don't match") });
            return;
        }

        if (password.length < 8) {
            this.setState({
                errored: Language.getString("Password needs to be 8 or more characters")
            });
            return;
        }

        const payload = { email, name, phone, pwd_hash: sha256(password) };
        Util.fetch_js(
            "/human/register/",
            payload,
            js => {
                const my_data = {
                    ...js.usr_info,
                    tenant: js.tenant
                };

                this.props.setUsrInfo(my_data);
                this.props.navigate(js.usr_info.portal)

                //If we're in a react-native app, send a message that the user is logged in
                if (window.ReactNativeWebView)
                    window.ReactNativeWebView.postMessage(js.usr_info);
            },
            (reason, code) => {
                this.setState({ errored: reason });
                console.log(reason);
            }
        );
    }

    render() {
        const { navigate, initial_tenant } = this.props
        const { errored, show_password } = this.state

        const logo = initial_tenant.full_logo || Logo
        const name = initial_tenant.name || "Drip7"

        return (
            <div className='register'>
                <div className='register-header'>
                    <div className="register-banner">
                        <div className='register-welcome'>
                            <div className="register-text">
                                <h1>Try the {name} Training</h1>
                                <p>&nbsp;</p>
                                <p>Register and try our platform for free — <span style={{'fontWeight': 'bold'}}>no credit card required.</span><span style={{'fontWeight': 'bold'}}></span></p>
                                <p><span><em>Register below for a free user experience trial – and experience the {name} difference. If you would like a platform administration trial, please contact sales.</em></span></p>
                            </div>
                        </div>
                        <div className="register-video">
                            <iframe loading="lazy"
                                title="Install Missing Plugin" 
                                src="https://player.vimeo.com/video/883430807?dnt=1&amp;app_id=122963" 
                                frameborder="0" allow="autoplay; fullscreen; picture-in-picture" 
                                data-player_id="883430807" 
                                data-player_url="https://player.vimeo.com/video/883430807" 
                                name="fitvid0" 
                                data-ready="true" 
                                data-player_title="Install Missing Plugin" 
                                data-player_duration="27">
                            </iframe>
                        </div>
                    </div>
                </div>
                <div className='register-menu'>
                    {errored != "" && (
                        <div className='register-error' role='alert' aria-atomic='true'>
                            <div className='register-error-wrap'>
                                <p>{Language.getString('error')}. {errored}.</p>
                            </div>
                        </div>
                    )}

                    <div className='register-fields'>
                        <InputWithIcon
                            inputProps={{
                                type: "input",
                                placeholder: Language.getString('name') + ' *',
                                name: "name",
                                autoCapitalize: "off",
                                autoComplete: "off",
                                autoCorrect: "off",
                                spellCheck: "false",
                                onKeyPress: this.handleKeypress,
                                onChange: this.handleChange
                            }}
                            icon={"icon user-icon"}
                        />

                        <InputWithIcon
                            inputProps={{
                                "aria-label":"Email",
                                type: "email",
                                placeholder: Language.getString('email') + ' *',
                                name: "email",
                                autoCapitalize: "off",
                                autoComplete: "off",
                                autoCorrect: "off",
                                spellCheck: "false",
                                onKeyPress: this.handleKeypress,
                                onChange: this.handleChange
                            }}
                            icon={"email-icon"}
                        />

                        <InputWithIcon
                            inputProps={{
                                "aria-label":"Password",
                                type: "password",
                                placeholder: Language.getString('password') + ' *',
                                name: "password",
                                autoCapitalize: "off",
                                autoComplete: "off",
                                autoCorrect: "off",
                                spellCheck: "false",
                                onKeyPress: this.handleKeypress,
                                onChange: this.handleChange
                            }}
                            icon={"icon lock-icon"}
                            secondIcon={"icon eye-icon"}
                        />

                        <InputWithIcon
                            inputProps={{
                                "aria-label": "Repeat Password",
                                type: "password",
                                placeholder: Language.getString('verify password') + ' *',
                                name: "password_repeat",
                                autoCapitalize: "off",
                                autoComplete: "off",
                                autoCorrect: "off",
                                spellCheck: "false",
                                onKeyPress: this.handleKeypress,
                                onChange: this.handleChange
                            }}
                            icon={"icon lock-icon"}
                            secondIcon={"icon eye-icon"}
                        />

                        <InputWithIcon
                            inputProps={{
                                type: "text",
                                placeholder: Language.getString('phone'),
                                name: "phone",
                                autoCapitalize: "off",
                                autoComplete: "off",
                                autoCorrect: "off",
                                spellCheck: "false",
                                onKeyPress: this.handleKeypress,
                                onChange: this.handleChange
                            }}
                            icon={"icon user-icon"}
                        />

                        <div className='register-help'>
                            <button
                                type='submit'
                                className='btn'
                                onClick={this.handleRegister}>
                                {Language.getTitleCase('register')}
                            </button>
                        </div>

                        <div className='register-help'>
                            <a href='#' onClick={() => navigate("/login")}>
                                {Language.getTitleCase('Back to Login')}
                            </a>
                        </div>

                        <div className='register-help'>
                            <p>{Language.getTitleCase('Need Help Logging In? Contact')}</p>
                            <a href='https://drip7.com/contact-us/'>{Language.getTitleCase('Support Center')}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const Register = withStore(Klass);
